import React, { useEffect, useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import styles from './sportstaettenManagement.module.css';
import defaultStyles from '../default.module.css';
import { Icons } from '../../../../code/IconHandler';
import axios from 'axios';
export default function SportstaetteCard({ sportstaette, onEdit, onDelete }) {
    const [images, setImages] = useState([]);
    const [sliderRef] = useKeenSlider({
        loop: true,
        slides: { perView: 1 },
        animation: {
            duration: 1000, // animation duration in milliseconds (1 second)
            easing: (t) => t, // optional easing function (linear here)
        },
    });
    useEffect(() => {
        if (!sportstaette || !sportstaette.id) return;
        axios.get(`/api/sportstaetten/images/${sportstaette.id}`)
            .then(res => {
                const data = res.data;
                if (Array.isArray(data)) {
                    setImages(data);
                } else if (data.images && Array.isArray(data.images)) {
                    setImages(data.images);
                } else {
                    setImages([]);
                }
            })
            .catch(err => {
                console.error("❌ Bilder laden fehlgeschlagen:", err);
                setImages([]);
            });
    }, [sportstaette]);

    const has = (field) => !!(sportstaette[field] && sportstaette[field].trim().length > 0);

    return (
        <div className={styles.card}>
            {/* Left: Carousel */}
            <div className={styles.imageCarousel}>
                <div ref={sliderRef} className="keen-slider">
                    {(images.length > 0 ? images : [{ image_path: '/images/logo.png' }]).map((img, idx) => (
                        <div className="keen-slider__slide" key={idx}>
                            <img src={img.image_path} alt={`Bild ${idx + 1}`} className={styles.image} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Right: Content & Actions */}
            <div className={styles.cardRight}>
                <div className={styles.cardContent}>
                    <h3>
                        {sportstaette.bezeichnung
                            ? `${sportstaette.bezeichnung} – ${sportstaette.name}`
                            : sportstaette.name}
                    </h3>
                    <p className={styles.address}>
                        {sportstaette.strasse}, {sportstaette.plz} {sportstaette.stadt}
                    </p>
                    <div className={styles.metaInfo}>
                        <small className={styles.linkName}>ID: {sportstaette.link_name}</small>

                        {/* Meta Info Icons */}

                        <span title="Ausstattung" className={`${styles.metaIcon} ${has('ausstattung') ? styles.active : styles.inactive}`}><Icons.Info /></span>
                        <span title="Anfahrt" className={`${styles.metaIcon} ${has('anfahrt') ? styles.active : styles.inactive}`}><Icons.Map /></span>
                        <span title="Verbote" className={`${styles.metaIcon} ${has('verbote') ? styles.active : styles.inactive}`}><Icons.Block /></span>
                        <span title="Bushaltestelle" className={`${styles.metaIcon} ${has('bushaltestelle') ? styles.active : styles.inactive}`}><Icons.Bus /></span>
                        {has('buslinien') && (
                            <div className={styles.busLines}>
                                {sportstaette.buslinien.split(',').map((line, idx) => (
                                    <span key={idx} className={styles.busBadge}>{line.trim()}</span>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Bus Lines */}

                </div>

                {/* Actions */}
                <div className={styles.cardActions}>
                    <button onClick={() => onEdit(sportstaette)} className={defaultStyles.greenButton}>
                        <Icons.Edit />
                    </button>
                    <button onClick={() => onDelete(sportstaette.id)} className={defaultStyles.redButton}>
                        <Icons.Delete />
                    </button>
                </div>
            </div>
        </div>
    );
}
